import {
  collection, addDoc, getDocs, query,
  where, updateDoc, serverTimestamp
} from 'firebase/firestore';
import { db } from '../config/firebase';
import { updateEventStatus } from './eventsService';
import { EventStatus } from '../types/event.types';

// 31 chars — sin 0/O, 1/I/L para evitar confusión visual
const CHARSET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';

export const generateToken = (): string => {
  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  return Array.from(bytes).map(b => CHARSET[b % CHARSET.length]).join('');
};

export const saveToken = async (
  token: string,
  eventId: string,
  userId: string,
  userEmail: string,
  paymentId?: string
): Promise<string> => {
  const ref = await addDoc(collection(db, 'publication_tokens'), {
    token,
    eventId,
    userId,
    userEmail,
    used: false,
    usedAt: null,
    paymentId: paymentId ?? null,
    createdAt: serverTimestamp(),
  });
  return ref.id;
};

export const redeemToken = async (
  inputToken: string,
  eventId: string,
  userId: string
): Promise<{ success: boolean; error?: string }> => {
  const normalized = inputToken.toUpperCase().trim();
  const q = query(
    collection(db, 'publication_tokens'),
    where('token', '==', normalized),
    where('eventId', '==', eventId),
    where('userId', '==', userId),
    where('used', '==', false)
  );
  const snap = await getDocs(q);
  if (snap.empty) return { success: false, error: 'token.invalid' };

  await updateDoc(snap.docs[0].ref, {
    used: true,
    usedAt: serverTimestamp(),
  });
  await updateEventStatus(eventId, EventStatus.PUBLISHED);
  return { success: true };
};
